"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemChanges = exports.ItemOperation = void 0;
var ItemOperation;
(function (ItemOperation) {
    ItemOperation[ItemOperation["None"] = 0] = "None";
    ItemOperation[ItemOperation["Added"] = 1] = "Added";
    ItemOperation[ItemOperation["Updated"] = 2] = "Updated";
    ItemOperation[ItemOperation["Deleted"] = 3] = "Deleted";
})(ItemOperation = exports.ItemOperation || (exports.ItemOperation = {}));
/**
 * Types of changes for tiles.
 * What each change means depends on specific scenario.
 */
var ItemChanges;
(function (ItemChanges) {
    /**
     * TextTile: Content of tile has changed.
     */
    ItemChanges[ItemChanges["ContentChanged"] = 0] = "ContentChanged";
    /**
     * TextTile: Content was previously empty (null, undefined, only white spaces).
     */
    ItemChanges[ItemChanges["ContentWasEmpty"] = 1] = "ContentWasEmpty";
    /**
     * FormattedTextTile: Formatting has changed.
     */
    ItemChanges[ItemChanges["FormattingChanged"] = 2] = "FormattingChanged";
})(ItemChanges = exports.ItemChanges || (exports.ItemChanges = {}));
//# sourceMappingURL=operations.js.map